/* eslint-disable no-undef */
/* eslint-disable no-useless-escape */
var moment = require('moment')
require('./moment-ferie-fr')
import { map, flatten, values, reduce } from 'underscore'
import { sortBy, prop, find, propEq, sum } from 'ramda'

var logoSecu = require('./logo_secu')
moment.locale('fr')

const FPA = 180 // 150 // 180 à partir du 11/09/21
const RAN = 60 // 50  //60 à partir du 11/09/21
const RAG = 120 // 100  // 120 à partir du 11/09/21

// arguments:
// xxx:
// listes: response from seq.Liste.findById Object with {id date jours[] }
// tbyMonth: appelé containTbm dans gardes.js, a simple object with as key the titulaire id as value the number of garde
// in the month, correctly incremented for holidays and sunday.
export function contentAstreintes (xxx, listes, tbyMonth) {
  var content = []
  var arrayOfFPARANRAGById = [] // array of array [id fpa ran rag]
  var sortBySecondItem = sortBy(prop(1))

  var functionRAN = function (date) {
    if (moment(date).isFerie() || moment(date).day() === 0) {
      return '1'
    } else {
      return ''
    }
  }
  var functionRAG = function (date) {
    if ( moment(date).day() === 6 || moment(date).isFerie() || moment(date).day() === 0) {
      return '1'
    } else {
      return ''
    }
  }
  var row = function () {
    var innerRow = []
    listes.joursByListeId.edges.forEach(function (jour) {
      if (jour.node.titulaireByTitulaireId !== null) {
        innerRow.push([
          moment(jour.node.date).format('dddd'),
          moment(jour.node.date).format('DD'),
          'X',
          '',
          jour.node.titulaireByTitulaireId.adeli,
          jour.node.titulaireByTitulaireId.nom.toUpperCase(),
          ' ',
          '1',
          functionRAN(jour.node.date),
          functionRAG(jour.node.date)
        ])
      }
    })
    innerRow = sortBySecondItem(innerRow)
    innerRow.unshift(['JOURS', 'DATES', 'A', 'G', 'NUMERO\nPRATICIEN', 'NOM DU MEDECIN', 'NOM DU\nREMPLACANT', 'Période complète\n(Nuit,dimanche,férié)',
      'Période\ndébut de\nnuit', 'Période nuit\nprofonde ou samedi\naprés-midi'
    ])
    return innerRow
  }
// Le total mensuel sur le tableau recapitulatif
  var rowt6 = function () {
    var innerRow = []
    innerRow.push([{
      rowSpan: 2, text: ' '
    }, {
      rowSpan: 2, text: 'Période complète (Nuit,\ndimanche,férié)\nFPA = 180 €'
    }, {
      rowSpan: 2, text: 'Période début de nuit\nRAN = 60 €'
    }, {
      rowSpan: 2, text: 'Période nuit profonde\nou samedi aprés-midi\nRAG = 120 €'
    }, {
      text: 'Total mensuel',
      colSpan: 2
    }, {}, {
      rowSpan: 2, text: 'Signature'
    }],
    ['',
      ' ',
      ' ',
      '',
      { colSpan:2, text: 'Montant'},
      ''
    ])
    xxx.edges.forEach(function (node) {
      console.log('the array', arrayOfFPARANRAGById)
      let obj = find(propEq('id', node.node.id))(arrayOfFPARANRAGById)
      innerRow.push([
        node.node.prenom.toUpperCase() + ' ' + node.node.nom.toUpperCase(),
        obj.fpa,// nombre FPA ,
        obj.ran,// nombre RAN
        obj.rag,// nombre RAG      
        {colSpan: 2, text:`${obj.fpa*FPA + obj.ran*RAN + obj.rag*RAG}`},// total
        '',
        ''
      ])
    })
    innerRow.push([
      'TOTAL',
      `${sum(map(arrayOfFPARANRAGById, 'fpa'))}`,// sum FPA
      `${sum(map(arrayOfFPARANRAGById, 'ran'))}`,
      `${sum(map(arrayOfFPARANRAGById, 'rag'))}`,
      {colSpan: 2, text: `${sum(map(arrayOfFPARANRAGById, 'fpa')) * 180 +
      sum(map(arrayOfFPARANRAGById, 'ran')) * 60 +
      sum(map(arrayOfFPARANRAGById, 'rag')) * 120}`},
      '',
      {text: '', fillColor: 'grey'}
    ])
    return innerRow
  }

  xxx.edges.forEach(function (row) {// for each user !
    content.push({
      image: logoSecu.image(),
      fit: [120, 120]
    })
    content.push({
      text: 'DPRS - Pôle Etudes et Paiements',
      // font: 'Times'
    })
    content.push({
      text: 'Site de Vienne',
      fontSize: 9
      // font: 'Times'
    })
    content.push({
      text: 'Tél. : 0 811 709 038',
      fontSize: 9
    })
    content.push({
      absolutePosition: {
        x: 230,
        y: 15
      },
      alignment: 'center',
      font: 'Times',
      text: [{
        text: 'Attestation de participation à la permanence des soins',
        fontSize: 14,
        bold: true
      },
      "\n en établissement de santé privé \nDemande individuelle de versement des indemnisations\n d\'astreintes et de gardes\n", {
        text: 'Document à envoyer par courrier postal rempli signé, sans rature ni surcharge',
        italics: true,
        fontSize: 10
      },
      "\nA\nCAISSE PRIMAIRE D\'ASSURANCE MALADIE DE L\'ISERE\n2 rue des Alliés\n38045 GRENOBLE Cedex "
      ]
    })
    content.push('\n')
    content.push('\n')
    content.push('\n')
    content.push({
      text: 'Mois et année de référence:' + moment(listes.date).format('MM') + '  /  ' + moment(listes.date).format('YYYY'),
      fontSize: 11,
      font: 'Roboto'

    })
    content.push('\n')
    content.push({
      table: {
        widths: [250, 140, 140],
        // font: 'Times',
        body: [
          ['Identification du praticien ', {
            text: 'Identification des praticiens remplaçants (le cas échéant)\nNom Prénom                      N° identification',
            colSpan: 2
          }, {}],
          ['NOM Prénom : ' + row.node.nom.toUpperCase() + ' ' + row.node.prenom.toUpperCase(), '', ''],
          ['N° identification:\t' + row.node.adeli, '', ''],
          ['Etablissement :  CLINIQUE DES CEDRES', '', ''],
          ['N° FINESS: \t 380785956', '', ''],
          ['Téléphone :   04 56 58 12 50', '', ''],
          ['Courriel : secret.anesthesie@cliniquedescedres.com', '', '']
        ]

      },
      layout: {
        hLineWidth: function () {
          return 0.5
        },
        vLineWidth: function () {
          return 0.5
        }
      }
    })
    content.push('\n')
    content.push('\n')
    content.push({
      text: `Nombre d'astreintes effectuées au cours du mois de référence :`
    })
    var ligne2 = ['Période complète\n(Nuit, dimanche,\nférié)', `FPA :\n${FPA} €`]
    
    var dataLigne2 = map(ligne2.concat(new Array(31)), function (elem) {
      if (elem === undefined) {
        return ' '
      } else {
        return elem
      }
    })
    var ligne3 = ['Période début de\nnuit', `RAN :\n${RAN} €`]
    var dataLigne3 = map(ligne3.concat(new Array(31)), function (elem) {
      if (elem === undefined) {
        return ' '
      } else {
        return elem
      }
    })

    var ligne4 = ['Période nuit \nprofonde ou samedi\naprés-midi', `RAG :\n${RAG} €`]
    var dataLigne4 = map(ligne4.concat(new Array(31)), function (elem) {
      if (elem === undefined) {
        return ' '
      } else {
        return elem
      }
    })

    var sumFPA = 0
    var sumRAN = 0
    var sumRAG = 0

    listes.joursByListeId.edges.forEach(function (jour) {
      for (var i = 1; i < 32; i++) {
        if (jour.node.titulaireByTitulaireId) {
          if (jour.node.titulaireByTitulaireId.id === row.node.id && moment(jour.node.date).date() === i) {
            if (moment(jour.node.date).day() === 0 || moment(jour.node.date).isFerie()) { //dimanche ou férié
              dataLigne2[i + 1] = '1'
              sumFPA += 1
              dataLigne3[i + 1] = '1' // 1 RAN 
              sumRAN += 1
              dataLigne4[i + 1] = '1' // 1 RAG
              sumRAG += 1

            } else if (moment(jour.node.date).day() === 6) { //samedi
              dataLigne2[i + 1] = '1'
              sumFPA += 1
              dataLigne4[i + 1] = '1' // 1 RAG
              sumRAG += 1
            } else {
              dataLigne2[i + 1] = '1'
              sumFPA += 1
            }
          }
        }
      }
    })

    content.push({
      style: 'table1', // table nombre d'astreintes effectuées au cours du mois de référence (individuelle)
      table: {
        widths: flatten([40, 30, Array.apply(0, Array(31)).map(function () {
          return 6
        })]),
        body: [
          [{
            text: 'Libellé / Code / Montant unitaire',
            colSpan: 2
          }, {}, '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
          dataLigne2, 
          dataLigne3,
          dataLigne4
        ]
      },
      layout: {
        hLineWidth: function () {
          return 0.5
        },
        vLineWidth: function () {
          return 0.5
        }
      }
    })
    content.push('\n')
    content.push({
      text: 'Je soussigné, Dr ' + row.node.prenom.toUpperCase() + ' ' + row.node.nom.toUpperCase() + ' déclare avoir participé à la permanence des soins aux dates'
    })
    content.push({
      text: "mentionnées ci-dessus, ouvrant droit au versement des forfaits d\'indemnisation, soit la somme de " + String((sumFPA * FPA) + (sumRAN * RAN) + (sumRAG * RAG)) + ' Euros.'
    })

    arrayOfFPARANRAGById.push({'id': row.node.id, 'fpa': sumFPA,'ran': sumRAN, 'rag': sumRAG})

    content.push('\n')

    content.push({
      text: 'Fait à Echirolles le ' + moment().format('DD/MM/YYYY')
    })
    content.push('\n')
    content.push({
      text: 'Signature et cachet du Médecin',
      pageBreak: 'after'
    })
  }) // end of each titulaire loop

  content.push({
    text: ('tableau des gardes et astreintes en etablissements - page 1').toUpperCase(),
    alignment: 'center',
    bold: true
  })
  content.push('\n')
  content.push({
    text: 'Mois et année de référence:\t' + moment(listes.date).format('MM') + '  /  ' + moment(listes.date).format('YYYY'),
    bold: true
  })
  content.push('\n')
  // TODO: table bold, police times
  content.push({
    style: 'table2',
    table: {
      widths: [550],
      // font: 'Times',
      body: [
        ['Etablissement : CLINIQUE DES CEDRES'],
        ['N° FINESS: 380785956'],
        ['Unité : ANESTHESIE'],
        ['Adresse : 21 RUE ALBERT LONDRES 38130 ECHIROLLES'],
        ['Téléphone : 04 56 58 12 50'],
        ['Courriel : ']
      ]
    },
    layout: {
      hLineWidth: function () {
        return 0.5
      },
      vLineWidth: function () {
        return 0.5
      }
    }
  })
  content.push('\n')
  content.push({
    text: 'A : Astreintes   G : Gardes'
  })
  content.push('\n')
  content.push({
    fontSize: 6,
    alignment: 'center',
    style: 'table2',
    pageBreak: 'after',
    table: {
      widths: [45, 55, 15, 15, 62, 75, 50, 55, 40, 55],
      height: function (i) {
        if (i === 0) {
          return 20
        }
        return 6
      },
      body: row()
    },
    layout: {
      hLineWidth: function () {
        return 0.5
      },
      vLineWidth: function () {
        return 0.5
      }
    }
  })
  //page 2 du récapitulatif
  content.push({
    text: ('tableau des gardes et astreintes en etablissements - page 2').toUpperCase(),
    alignment: 'center',
    bold: true
  })
  content.push('\n')
  content.push({
    text: 'Mois et année de référence:\t' + moment(listes.date).format('MM') + '  /  ' + moment(listes.date).format('YYYY'),
    bold: true
  })
  content.push('\n')
  content.push({
    text: 'Astreintes'
  })
  content.push('\n')
  content.push({
    fontSize: 6,
    alignment: 'center',
    table: {

      widths: [75, 75, 80, 62, 50, 50, 100],
      height: function (i) {
        if (i === 0) {
          return 18
        }
        return 11
      },
      body: rowt6()
    },
    layout: {
      hLineWidth: function () {
        return 0.5
      },
      vLineWidth: function () {
        return 0.5
      },
      paddingBottom: () => 0
    }
  })
  content.push('\n')
  content.push('\n')
  content.push({
    fontSize: 9,
    widths: [160, 160, 160],
    table: {
      body: [
        [
          'MEDECIN RESPONSABLE DU RESEAU', "DIRECTEUR DE L'ETABLISSEMENT", "CACHET DE L'ETABLISSEMENT"
        ],
        [
          'Signature du responsable du réseau', 'Signature', ''

        ],
        [
          '', '(Avec mention écrite: tableau valant attestation de service fait )', ''
        ]
      ]
    },
    layout: 'noBorders'
  })
  return content
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/astreintes_print.js